import { Action } from 'redux'
import { NotificationActions } from '../../reducers/userAccount/actionNames'

const loadNotificationPage = (
  page: number,
  lastModifyDate: Date = null,
): ILoadNotificationPage => ({
  lastModifyDate,
  page,
  type: NotificationActions.LoadPage,
})

const notificationPageAccepted = (
  notifications,
  hasMore = false,
  ids: string[],
): INotificationPageAccepted => ({
  hasMore,
  ids,
  notifications,
  type: NotificationActions.PageAccepted,
})

const notificationSyncAccepted = (
  ids: string[],
  notifications,
): INotificationSyncAccepted => ({
  ids,
  notifications,
  type: NotificationActions.SyncAccepted,
})

export interface ILoadNotificationPage
  extends Action<NotificationActions.LoadPage> {
  page: number
  lastModifyDate?: Date
  reload?: boolean
}

export interface INotificationPageAccepted
  extends Action<NotificationActions.PageAccepted> {
  hasMore: boolean
  ids: string[]
  notifications: any // temp
}

export interface INotificationSyncAccepted
  extends Action<NotificationActions.SyncAccepted> {
  ids: string[]
  notifications: any
}

export default loadNotificationPage
export { notificationPageAccepted, notificationSyncAccepted }
